var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comma"},_vm._l((_vm.diff),function(row){return _c('span',[_vm._v(_vm._s(row.t))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }